import $ from 'jquery';

/**
 * On clicking a message close button message is removed
 *
 * @class SiteMessageView
 * @constructor
 */

export default class SiteMessageView {
    constructor() {

        /**
         * A referenc to the body
         *
         * @property $body
         * @type {jQuery}
         * @public
         */
        this.$body = $('body');

        /**
         * A reference to the triggering DOM element
         *
         * @property $trigger
         * @type {jQuery}
         * @public
         */
        this.$trigger = null;

        /**
         * Closest container ".siteMessage"
         *
         * @property container
         * @type {jQuery}
         * @public
         */
        this.$container = null;

        // engage
        this.enable();
    }

    /**
     * Method create children    
     *
     * @method createChildren
     * @chainable
     * @public
     */
    createChildren(event) {
        this.$trigger = $(event.target);
        this.$container = this.$trigger.closest('.siteMessage');
    }

    /**
     * Method enable
     *
     * @method enable
     * @chainable
     * @public
     */
    enable() {

        this.$body.on('click', '.js-siteMessageClose', (e) => {
            this.createChildren()
                .removeMessage();
            return this;
        });
    }

    /**
     * Method to remove message
     *   
     * @method removeMessage
     * @chainable
     * @public
     */
    removeMessage() {

        this.$container.remove();

        return this;
    }

}